import { getNodeIssues } from './useCsmlNodeMeta';
import { getOutPorts } from './useCsmlPorts';
import { nodeHasInvalidApiJson } from './useCsmlGenerator';

// Problems that do not stop the bot from working, only make it less useful.
const WARNING_ISSUES = ['NOT_DELIVERED'];

/**
 * Everything worth flagging about the flow as a whole, in one list the top
 * bar can summarise and the user can click through.
 *
 * Each entry is `{ id, severity, key, nodeId, count }`. `key` is a path under
 * AGENT_BOTS.VISUAL_BUILDER, `nodeId` is the node to jump to (null for
 * flow-wide problems) and `count` feeds pluralised messages.
 */
export function collectIssues(nodes, connections, { lossy = false } = {}) {
  const issues = [];

  if (!nodes.some(node => node.type === 'start')) {
    issues.push({
      id: 'no-start',
      severity: 'error',
      key: 'TOAST.START_REQUIRED',
      nodeId: null,
      count: 1,
    });
  }
  if (lossy) {
    issues.push({
      id: 'lossy',
      severity: 'warning',
      key: 'TOAST.LOSSY_SAVE',
      nodeId: null,
      count: 1,
    });
  }

  nodes.forEach(node => {
    getNodeIssues(node).forEach(issue => {
      issues.push({
        id: `${node.id}-${issue}`,
        severity: WARNING_ISSUES.includes(issue) ? 'warning' : 'error',
        key: `ISSUES.${issue}`,
        nodeId: node.id,
        count: 1,
      });
    });

    if (nodeHasInvalidApiJson(node)) {
      issues.push({
        id: `${node.id}-api-json`,
        severity: 'error',
        key: 'TOAST.API_JSON_INVALID',
        nodeId: node.id,
        count: 1,
      });
    }

    // A single-port node that goes nowhere simply ends the flow, which is
    // fine; a node that forks but leaves a branch dangling is not.
    const ports = getOutPorts(node);
    if (ports.length > 1) {
      const wired = new Set(
        connections
          .filter(conn => conn.fromId === node.id)
          .map(conn => conn.fromPortIdx ?? 0)
      );
      const unwired = ports.filter(port => !wired.has(port.idx)).length;
      if (unwired) {
        issues.push({
          id: `${node.id}-unwired`,
          severity: 'warning',
          key: 'ISSUES.UNWIRED_BRANCHES',
          nodeId: node.id,
          count: unwired,
        });
      }
    }
  });

  return issues;
}
